"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var castArray_1 = __importDefault(require("lodash/castArray"));
var isArray_1 = __importDefault(require("lodash/isArray"));
var toString_1 = __importDefault(require("lodash/toString"));
var react_1 = __importDefault(require("react"));
var index_1 = __importDefault(require("./index"));
var MultipleValueFilterItem = /** @class */ (function (_super) {
    __extends(MultipleValueFilterItem, _super);
    function MultipleValueFilterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validOperators = ["in"];
        _this.selectAll = function (e) {
            var selectedValues = [];
            if (e.target.checked) {
                // For some reason TSC compiler thinks `item.id` can be React.Text...
                selectedValues = _this.values.map(function (item) { return toString_1.default(item.id); });
            }
            _this.setState({
                selectedValues: selectedValues,
            });
        };
        _this.checkValue = function (e, value) {
            var add = e.target.checked;
            var selectedValues = _this.state.selectedValues;
            // Convert to array if it is not, unfortunatelly
            // this is not for TS :(
            var arr = selectedValues;
            if (!arr) {
                arr = [];
            }
            else if (!isArray_1.default(arr)) {
                arr = [selectedValues];
            }
            if (add) {
                arr.push(value);
            }
            else {
                arr.splice(arr.indexOf(value), 1);
            }
            _this.setState({
                selectedValues: arr.length ? arr : undefined,
            });
        };
        _this.renderSelect = function () {
            var localization = _this.props.localization;
            var _a = _this.state, selectedValues = _a.selectedValues, filter = _a.filter;
            var select;
            if (filter.length > 0) {
                select = react_1.default.createElement("strong", null, localization.foundResults.replace("%COUNT", "" + _this.filteredValues.length));
            }
            else {
                /* eslint-disable @typescript-eslint/restrict-template-expressions */
                select = (react_1.default.createElement("label", { key: _this.props.id + "_select_all" },
                    react_1.default.createElement("input", { type: "checkbox", checked: castArray_1.default(selectedValues).length === Object.keys(_this.values).length, onChange: _this.selectAll }),
                    react_1.default.createElement("strong", null, localization.selectAll)));
                /* eslint-enable @typescript-eslint/restrict-template-expressions */
            }
            return select;
        };
        _this.renderRows = function () {
            var selectedValues = _this.state.selectedValues;
            return _this.filteredValues.map(function (item) {
                var key = toString_1.default(item.id);
                var value = item.name;
                var isChecked = castArray_1.default(selectedValues).indexOf(key) >= 0;
                var handler = function (e) {
                    _this.checkValue(e, key);
                };
                return (react_1.default.createElement("label", { key: "option_" + item.id + "_" + value.replace(/ /g, "_"), className: "option" },
                    react_1.default.createElement("input", { type: "checkbox", checked: isChecked, onChange: handler }),
                    react_1.default.createElement("span", { className: "text" }, value)));
            });
        };
        return _this;
    }
    return MultipleValueFilterItem;
}(index_1.default));
exports.default = MultipleValueFilterItem;
//# sourceMappingURL=MultipleValueFilterItem.js.map